import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const ConfirmModal = ({ open, title, desc, confirmLabel, onConfirm, onCancel }) => (
  <AnimatePresence>
    {open && (
      <div className="fixed inset-0 z-[300] flex items-center justify-center px-6">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 bg-slate-950/80 backdrop-blur-sm"
          onClick={onCancel}
        />
        <motion.div
          initial={{ opacity: 0, scale: 0.88, y: 16 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ type: 'spring', damping: 24, stiffness: 300 }}
          className="relative z-10 w-full max-w-xs bg-[#0e1829] border border-white/10 rounded-3xl p-6 shadow-2xl"
        >
          <div className="flex justify-center mb-4">
            <div className="w-14 h-14 rounded-2xl bg-rose-500/15 border border-rose-500/25 flex items-center justify-center text-2xl">
              ⚠️
            </div>
          </div>
          <h3 className="text-lg font-black text-white text-center mb-2">{title}</h3>
          <p className="text-sm text-white/50 text-center mb-6">{desc}</p>
          <div className="flex flex-col gap-2.5">
            <button
              onClick={onConfirm}
              className="w-full py-3.5 bg-rose-500 hover:bg-rose-400 text-white font-black rounded-2xl transition-all active:scale-95 text-sm"
            >
              {confirmLabel}
            </button>
            <button
              onClick={onCancel}
              className="w-full py-3.5 bg-white/5 text-white/60 font-black rounded-2xl border border-white/10 hover:bg-white/10 transition-all active:scale-95 text-sm"
            >
              取消
            </button>
          </div>
        </motion.div>
      </div>
    )}
  </AnimatePresence>
)

export default ConfirmModal